import React, { useEffect, useState } from "react";
import Carousel from "../components/Carousel";
import CarouselEmptyState from "../components/CarouselEmptyState";
import { userStats } from "../actions/userStats";
import Footer from "../components/Footer";
import { propertyStats } from "../actions/propertyStats";
import { AiOutlineSearch } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { propertiesPopular } from "../actions/propertiesPopular";
import { propertiesRecent } from "../actions/propertiesRecent";
import { propertiesSoldRecent } from "../actions/propertiesSoldRecent";
import { leasedProperties } from "../actions/leasedProperties";
import { SHOW_ADS } from "../constants/FeatureFlags";
const Home = () => {
  const [stats, setStats] = useState(null);
  const [propStats, setPropStats] = useState(null);
  const [propertiesPopularr, setPropertiesPopularr] = useState(null);
  const [propertiesRecentt, setPropertiesRecentt] = useState(null);
  const [propertiesSoldRecentt, setPropertiesSoldRecentt] = useState(null);
  const [propertiesLeasedRecentt, setPropertiesLeasedRecentt] = useState(null);
  const [search, setSearch] = useState(null);
  // No filter needed - SQL already returns only Active properties
  const recentActive = propertiesRecentt;

  useEffect(() => {
    if (typeof setPropertiesPopularr === "function") {
      propertiesPopular({ setPropertiesPopular: setPropertiesPopularr });
    } else {
    }
    propertiesRecent({ setPropertiesRecentt });
    propertiesSoldRecent({ setPropertiesSoldRecentt });
    leasedProperties({ setProperties: setPropertiesLeasedRecentt });
    userStats({ setStats });
    propertyStats({ setPropStats });
  }, []);

  function MoneyFormat(labelValue) {
    const num = Number(labelValue);
    if (!Number.isFinite(num)) return 0;
    const abs = Math.abs(num);
    return abs >= 1.0e9
      ? abs / 1.0e9 + "B"
      : abs >= 1.0e6
        ? abs / 1.0e6 + "M"
        : abs >= 1.0e3
          ? abs / 1.0e3 + "K"
          : abs;
  }
  const nav = useNavigate();
  const handleSearch = () => {
    if (!search || String(search).trim() === "") {
      nav(`/active`);
    } else {
      nav(`/active?q=${encodeURIComponent(search)}`);
    }
  };
  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="w-full h-[500px] relative">
          <div
            aria-hidden="true"
            className="h-full w-full bg-gradient-to-br from-blue-200 via-blue-400 to-blue-600"
          />
          <div className="absolute top-0 w-full h-full flex flex-col justify-center items-center text-white uppercase font-bold gap-6">
            <div className="bg-black/50 px-8 py-2 rounded-10">
              <h1 className="header-text:text-30 text-19 [text-shadow:_0px_0px_0px_rgb(0_0_0_/_100%)]">
                Looking for a property?
              </h1>
              <div className="flex items-center relative text-black">
                <input
                  className="w-full rounded-full px-4 py-2"
                  type="text"
                  placeholder="Search by key number"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <AiOutlineSearch
                  className="absolute text-black right-4 hover:scale-105 hover:cursor-pointer transition-all"
                  size={30}
                  onClick={() => handleSearch()}
                />
              </div>
            </div>
            <div className="bg-black/50 px-8 py-2 rounded-10">
              <p className="header-text:text-30 text-19 [text-shadow:_0px_0px_0px_rgb(0_0_0_/_100%)]">
                Welcome Home.
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-6">
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    {stats?.total}
                  </h1>
                  <p className="header-text:text-19 text-xs font-medium">
                    Total Users
                  </p>
                </div>
              </div>
              {/* <div className="bg-black/50 px-8 py-2 rounded-10">
              <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">{stats?.today}</h1>
                  <p className="header-text:text-19 font-medium text-xs">users today</p>
                </div>
            </div> */}
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    {propStats?.total ?? 0}
                  </h1>
                  <p className="header-text:text-19 text-xs font-medium">
                    Active Properties Listed
                  </p>
                </div>
              </div>
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    ${MoneyFormat(propStats?.cost ?? 0)}
                  </h1>
                  <p className="header-text:text-19 font-medium text-xs">
                    Active Listed Property Volume
                  </p>
                </div>
              </div>
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    {propStats?.soldTotal ?? 0}
                  </h1>
                  <p className="header-text:text-19 text-xs font-medium">
                    Properties Sold
                  </p>
                </div>
              </div>
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    ${MoneyFormat(propStats?.soldCost ?? 0)}
                  </h1>
                  <p className="header-text:text-19 font-medium text-xs">
                    Sold Property Volume
                  </p>
                </div>
              </div>
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    {propStats?.leasedTotal ?? 0}
                  </h1>
                  <p className="header-text:text-19 text-xs font-medium">
                    Properties Leased
                  </p>
                </div>
              </div>
              <div className="bg-black/50 px-8 py-2 rounded-10">
                <div className="flex flex-col gap-2 items-center">
                  <h1 className="header-text:text-52 font-bold text-3xl">
                    ${MoneyFormat(propStats?.leasedCost ?? 0)}
                  </h1>
                  <p className="header-text:text-19 font-medium text-xs">
                    Leased Property Volume
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Property Carousels Section */}
      <main className="property-carousels-section w-full mt-8">
        <div className="px-4 tablet:px-0 w-full mb-4">
          <h1 className="homepage-categories:text-30 text-lg py-6 px-6 shadow-md bg-slate-100">
            Recently Listed Properties
          </h1>
          <hr />
          {recentActive && recentActive.length > 0 ? (
            <Carousel properties={recentActive}></Carousel>
          ) : (
            <CarouselEmptyState type="recent" />
          )}
        </div>
        <div className="px-4 tablet:px-0 w-full mb-4">
          <h1 className="homepage-categories:text-30 text-lg py-6 px-6 shadow-md bg-slate-100">
            Most Popular Properties
          </h1>
          <hr />
          {propertiesPopularr && propertiesPopularr.length > 0 ? (
            <Carousel properties={propertiesPopularr}></Carousel>
          ) : (
            <CarouselEmptyState type="popular" />
          )}
        </div>
        {/* <div className="px-4 tablet:px-0 w-full pr-0 advertisment:pr-8 relative -top-0  carousel-top:-top-36">
              <h1 className="homepage-categories:text-30 text-lg py-6 px-6 shadow-md bg-slate-100">New Price</h1>
              <hr/>
              <Carousel properties={properties}></Carousel>
    </div> */}
        <div className="px-4 tablet:px-0 w-full mb-4">
          <h1 className="homepage-categories:text-30 text-lg py-6 px-6 shadow-md bg-slate-100">
            Just Sold
          </h1>
          <hr />
          {propertiesSoldRecentt && propertiesSoldRecentt.length > 0 ? (
            <Carousel properties={propertiesSoldRecentt}></Carousel>
          ) : (
            <CarouselEmptyState type="sold" />
          )}
        </div>
        <div className="px-4 tablet:px-0 w-full mb-4">
          <h1 className="homepage-categories:text-30 text-lg py-6 px-6 shadow-md bg-slate-100">
            Just Leased
          </h1>
          <hr />
          {propertiesLeasedRecentt && propertiesLeasedRecentt.length > 0 ? (
            <Carousel properties={propertiesLeasedRecentt}></Carousel>
          ) : (
            <CarouselEmptyState type="leased" />
          )}
        </div>
        <div className="w-full flex justify-center py-8">
          <button
            className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium text-lg shadow-md"
            onClick={() => nav(`/active`)}
          >
            View Active Listings
          </button>
        </div>
        {/* Spacer to avoid overlap with fixed bottom ad */}
        {SHOW_ADS ? <div className="h-28 tablet:h-32"></div> : null}
      </main>

      <Footer />
    </>
  );
};

export default Home;
